import {Text, View} from "react-native";
import {Button} from "../../../../shared/button";
import * as React from "react";

export const PickupRequestsRemaining = ({
                                            onAskPickup,
                                            nbAvailableThisMonth
                                        }) => <View style={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Text style={{fontSize: 22, color: 'white', fontWeight: 'bold'}}>{nbAvailableThisMonth} pick up request{nbAvailableThisMonth > 1 ? 's' : ''}</Text>
        <Text style={{fontSize: 14, color: 'white', marginBottom: 15}}>available this month</Text>
        {nbAvailableThisMonth > 0 && <View style={{marginBottom: 15}}><Button appearance="ghost" onPress={onAskPickup}>Ask pick up</Button></View>}
</View>